import { useEffect, useContext } from 'react';
import { mapPinType } from '../constants/products';
import { buildHotelDetailURL } from './HotelListingCard/buildHotelDetailURL';
import { ChatbotDataContext } from '../context/ChatbotDataContext';
export const expressDealHotelId = hotel => {
  var _a, _b;
  if (!hotel || typeof hotel !== 'object') return '';
  const neighborhoodName = (_a = hotel.location) === null || _a === void 0 ? void 0 : _a.neighborhoodName;
  if (hotel.sopqDealName && neighborhoodName) {
    return `${hotel.sopqDealName}-${neighborhoodName}-${(_b = hotel.ratesSummary) === null || _b === void 0 ? void 0 : _b.grandTotal}`;
  }
  return '';
};
export const useSetHotelPinOnMapHook = ({
  displayResult,
  args,
  displaySopqOnly
}) => {
  const {
    setHotelPinOnMap,
    hotelOnMapList
  } = useContext(ChatbotDataContext);
  useEffect(() => {
    var _a, _b, _c;
    const availableNames = (_a = hotelOnMapList === null || hotelOnMapList === void 0 ? void 0 : hotelOnMapList.map(p => p === null || p === void 0 ? void 0 : p.name)) === null || _a === void 0 ? void 0 : _a.join(',');
    const newNames = (_b = displayResult === null || displayResult === void 0 ? void 0 : displayResult.map(h => (h === null || h === void 0 ? void 0 : h.name) || 'hotel')) === null || _b === void 0 ? void 0 : _b.join(',');
    if (availableNames !== newNames) {
      const hotelLocationList = (_c = displayResult === null || displayResult === void 0 ? void 0 : displayResult.filter(hotel => hotel.location && hotel.location.latitude && hotel.location.longitude)) === null || _c === void 0 ? void 0 : _c.map(hotel => {
        const isExpressDeal = hotel.hotelType === 'SOPQ';
        return {
          type: mapPinType.HOTEL,
          name: (hotel === null || hotel === void 0 ? void 0 : hotel.name) || 'hotel',
          description: hotel === null || hotel === void 0 ? void 0 : hotel.description,
          location: hotel.location,
          lat: hotel.location.latitude,
          lng: hotel.location.longitude,
          hotelDetailURL: buildHotelDetailURL(args, hotel),
          hotel: Object.assign(Object.assign({}, hotel), {
            hotelId: isExpressDeal ? expressDealHotelId(hotel) : String(hotel === null || hotel === void 0 ? void 0 : hotel.hotelId)
          })
        };
      });
      setHotelPinOnMap(hotelLocationList);
    }
  }, [displaySopqOnly, displayResult]);
};